export const DEFAULT_PROJECT = 'fall26';
export const DEFAULT_ROUTE = `/${DEFAULT_PROJECT}/`;

export const TOKEN_KEY = `auth-${location.pathname.split('/')[1] || DEFAULT_PROJECT.toString()}`;

export const MSG_USER_NOT_WHITELISTED =
  'Use the same email we used to contact you (for example the email address your invitation was sent to).';

export const BUDDY_PROJECTS = ['13', 'buddyfall25', '15', 'buddyspring26', '17', 'buddyfall26'];

export const CACHE_TIMES = {
  SHORT: 5 * 60 * 1000, // 5 minutes
  DEFAULT: 10 * 60 * 1000, // 10 minutes
  LONG: 30 * 60 * 1000, // 30 minutes
  INFINITE: Infinity, // never refetch
};

export const COLLAPSE_BREAK_MARKER = '<!--COLLAPSE-->';
